export default __webpack_public_path__ + "static/media/infografia_voluntariado.b54e1376.pdf";